import request from '@/common/request'
/** 
 *  create 增
 *  delete 删
 *  update 改
 *  query  查
*/
export default {
    // 任务执行统计
    getTaskCarriedOut: () => {
        return request({
            url: '/v1/statistics/task/getTaskCarriedOut',
            method: 'get',
        })
    },
    // 任务状态统计
    getAnyTaskStatus: () => {
        return request({
            url: '/v1/statistics/task/getAnyTaskStatus',
            method: 'get',
        })
    },
    // 任务操作类型
    getAnyTaskType: () => {
        return request({
            url: '/v1/statistics/task/getAnyTaskType',
            method: 'get',
        })
    },
    // 人员工作量统计
    getOperateWorkload: () => {
        return request({
            url: '/v1/statistics/task/getOperateWorkload',
            method: 'get',
        })
    },
    // 锁使用统计
    usageStatistic: () => {
        return request({
            url: '/v1/statistics/lock/usageStatistic',
            method: 'get',
        })
    },
    // 钥匙电量统计
    batteryStatistic: () => {
        return request({
            url: '/v1/statistics/key/batteryStatistic',
            method: 'get',
        })
    },
    // 钥匙使用统计
    usagekeyStatistic: () => {
        return request({
            url: '/v1/statistics/key/usageStatistic',
            method: 'get',
        })
    },
    // 钥匙状态
    stateStatistic: () => {
        return request({
            url: '/v1/statistics/key/stateStatistic',
            method: 'get',
        })
    },
    //锁异常
    exceptionDataStatistic: () => {
        return request({
            url: '/v1/statistics/lock/exceptionDataStatistic',
            method: 'get',
        })
    },
    // 钥匙最新操作坐标
    currentCoordinates: () => {
        return request({
            url: '/v1/statistics/key/currentCoordinates',
            method: 'get',
        })
    },
    // 锁最新操作坐标
    currentLockCoordinates: () => {
        return request({
            url: '/v1/statistics/lock/currentCoordinates',
            method: 'get',
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/modules/taskOverview.js